<script setup lang="ts">

</script>
<template>
  <ToastController class="toasts" v-slot="{ toasts }">
    <UiToastContainer :toasts="toasts" />
  </ToastController>
</template>
<style scoped lang="scss">
  .toasts {
    display: contents;
  }
</style>
